{
  "payments": "Payments",
  "years-range-title": "Years",
  "years-range": "Years Ranges",
  "principalInterest": "Principal & Interest",
  "interestOnly?": "Interest Only?",
  "interestOnly": "Interest Only",
  "no": "No",
  "mortgageInsurance": "Mortgage Insurance",
  "estimatedEscrow": "Estimated Escrow",
  "amount": "Amount",
  "range": "Range",
  "estimated-taxes-title": "Estimated Taxes, Insurances & Assessments",
  "per-month": "Per Month",
  "per-week": "Per Week",
  "includes": "Includes",
  "inEscrow": "In Escrow",
  "propertiesTaxes": "Property Taxes",
  "homeownersInsurance": "Homeowner's Insurance",
  "other": "Other",
  "addADescription": "Add a Description...",
  "min": "Min",
  "max": "Max",
  "invalidNumber": "Invalid Number",
  "minGreaterThanMax": "Min cannot be greater than Max",
  "invalidInteger": "Invalid Integer",
  "requiredField": "Required Field",
  "formChanged": "These changes affect the order and must be completely reviewed",
  "escrowInfoMessage": "The information here depends on the switches above",
  "mortgage-insurance": "Mortgage Insurance",
  "calculated-value-is": "The calculated value is:",
  "calculated-value-modified": "The calculated value was modified"
}
